import { render, staticRenderFns } from "./deviceFunFan.vue?vue&type=template&id=54e640ea&"
import script from "./deviceFunFan.vue?vue&type=script&lang=js&"
export * from "./deviceFunFan.vue?vue&type=script&lang=js&"
import style0 from "./deviceFunFan.vue?vue&type=style&index=0&id=54e640ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports